import React from 'react';

function GoogleIcon({ className = 'h-5 w-5' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.02 1.54 7.4 2.82l5.4-5.4C33.52 3.84 29.16 2 24 2 14.62 2 6.6 7.38 2.74 15.2l6.58 5.11C11.36 13.9 17.18 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46 24.5c0-1.62-.14-2.8-.44-4.04H24v7.66h12.52c-.25 2.03-1.6 5.09-4.62 7.14l7.1 5.5C43.1 34.02 46 29.6 46 24.5z"
      />
      <path
        fill="#FBBC05"
        d="M9.32 28.31A14.6 14.6 0 0 1 8.5 24c0-1.5.26-2.94.79-4.31L2.74 15.2A23.9 23.9 0 0 0 0 24c0 3.86.93 7.51 2.74 10.8l6.58-5.11z"
      />
      <path
        fill="#34A853"
        d="M24 46c6.16 0 11.32-2.02 15.1-5.5l-7.1-5.5c-1.9 1.32-4.46 2.24-8 2.24-6.82 0-12.64-4.4-14.68-10.43L2.74 35.8C6.6 43.62 14.62 46 24 46z"
      />
      <path fill="none" d="M0 0h48v48H0z" />
    </svg>
  );
}

export default GoogleIcon;

